"use client";

import { motion } from "framer-motion";
import { useParams } from "next/navigation";
import { messages } from "@/lib/i18n";
import { HiDesktopComputer } from "react-icons/hi";
import Image from "next/image";

export default function CaseStudiesCreativeGrid() {
  const params = useParams();
  const locale = (params?.locale ?? "en") as "en" | "ar" | "fr";
  const t = messages[locale] ?? messages.en;
  const items = t.caseStudies.items;
  const isRTL = locale === "ar";

  return (
    <section
      id="case-studies"
      className="relative w-full bg-black py-32 px-4 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl">
        <div className="mb-28 text-center">
          <h2 className="text-5xl md:text-6xl font-extrabold text-white">
            {t.caseStudies.title}
          </h2>
          <p className="mt-4 text-gray-400 text-lg">{t.caseStudies.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-14">
          {items.map((item, index) => {
            const motionProps = {
              initial: { opacity: 0, y: 60, scale: 0.95 },
              animate: { opacity: 1, y: 0, scale: 1 },
              whileHover: { y: -15, scale: 1.02 },
              transition: { duration: 0.7, delay: index * 0.15 },
            } as any;

            const linkMotion = { whileHover: { scale: 1.05 } } as any;

            return (
              <motion.div
                key={index}
                {...motionProps}
                className="
                relative min-h-[390px]
                glass-panel-gold neon-card
                rounded-3xl p-10 pt-14
                shadow-lg hover:shadow-2xl
                flex flex-col justify-between
                overflow-visible
              "
              >
                <div className="absolute left-1/2 top-0 z-20 -translate-x-1/2 -translate-y-1/2">
                  <div className="logo_bubble_gray">
                    <Image
                      src={item.applogo}
                      alt={item.name}
                      width={44}
                      height={44}
                      className="w-11 h-11 object-contain opacity-95"
                    />
                  </div>
                </div>
                <div className="relative z-10 flex-1">
                 
                     <h3 className="text-3xl font-bold text-white mb-2">
                    {item.name}
                  </h3>
                
                 

                  <p className="text-sm  md:text-lg font-bold uppercase tracking-widest text-yellow-400/50 mb-5">
                    {item.date}
                  </p>

                  <p className="text-gray-300 leading-relaxed">
                    {item.description}
                  </p>
                </div>
                <motion.a
                  {...linkMotion}
                  href={item.liveDemo}
                  target="_blank"
                  className="
                  mt-8 inline-flex items-center justify-center gap-2
                  px-6 py-3 rounded-full
                  bg-yellow-500/20 text-yellow-400
                  font-medium
                  hover:bg-yellow-500/30
                  transition-all
                "
                >
                  {locale === "ar"
                    ? "عرض المشروع"
                    : locale === "fr"
                    ? "Voir le projet"
                    : "View Project"}
                  <HiDesktopComputer className="w-5 h-5" />
                </motion.a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
